import React, { useEffect, useState } from 'react'
import { messages } from '../../config/config'
import useAuth from '../../hooks/useAuth'
import { useConfig } from '../../contexts/ConfigContext'
import { useSecureRequest } from '../../hooks/useSecureRequest'
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Layout, Row, Spin } from 'antd'
import FooterLayout from '../Footer';

const { Content } = Layout;

function ChangePassword() {
  const params = new URLSearchParams(globalThis.location.search)
  const fromLogin = params.get('fromLogin') === 'true'
  const emailParam = params.get('email') || ''
  const oldPasswordParam = params.get('id') || ''
  
  const { tokenData } = useAuth.useToken()
  const { config, updateConfig } = useConfig()
  const { securePost } = useSecureRequest()
  const [spinning, setSpinning] = useState(true)
  const [form] = Form.useForm()
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
 
  const { content, error } = useAuth.useIndex(tokenData,fromLogin)

  useEffect(() => {
    if (tokenData && content) {
      updateConfig({...content, key:tokenData.key, token:tokenData.token})
      setSpinning(false)
    }
    const handleResize = () => setIsMobile(window.innerWidth < 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [tokenData, content])

  useEffect(() => {
    if (error) {
      alert('No fue posible conectar con el servidor')
      setSpinning(false)
    }
  }, [error])

  const handleChangePassword = async (values: any) => {
    setSpinning(true)
    
    // Validate that new password and confirm password match
    if (values.newPassword !== values.confirmPassword) {
      updateConfig({
        errorMessage: 'Las contraseñas no coinciden'
      })
      setSpinning(false)
      return
    }

    // Validate that new password is different from old password
    const oldPassword = fromLogin ? oldPasswordParam : values.oldPassword
    if (values.newPassword === oldPassword) {
      updateConfig({
        errorMessage: 'La nueva contraseña debe ser diferente a la actual'
      })
      setSpinning(false)
      return
    }

    const data = {
      email: fromLogin ? emailParam : values.email,
      oldPassword: oldPassword,
      newPassword: values.newPassword
    }

    const changePasswordResponse = await securePost('/security/auth/change-password', data)
    
    if (changePasswordResponse.status === 200) {
      updateConfig({
        errorMessage: changePasswordResponse.message || 'Contraseña actualizada exitosamente. Redirigiendo...'
      })
      setTimeout(() => {
        globalThis.location.href = '/login'
      }, 2000)
    } else {
      updateConfig({
        errorMessage: changePasswordResponse.errorMessage || 'Error al actualizar la contraseña'
      })
    }
    setSpinning(false)
  }

  const configMessages = fromLogin ? messages.changePassword.forced : messages.changePassword.generic

  return (
    <Layout style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Spin size="large" tip="Cargando..." fullscreen spinning={spinning} />
      <Content style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", padding: 10 }}>
        <Card style={{ width: "90%", maxWidth: 800, minHeight: "70vh", display: "flex", flexDirection: "column", justifyContent: "center", margin: 40, boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)", borderRadius: 12 }}>
          <Row justify="center" gutter={16}>
            <Col xs={20} sm={14} md={14} lg={9} xl={10}>
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center" }}>
                <div style={{ flex: 1, padding: 20 }}>
                  <h4 className="title-login" style={{ textAlign: "center" }}>{config.title}</h4>
                  <p style={{ marginBottom: "1.5rem", color: "#858796", textAlign: "center" }}>{config.message}</p>
                  <Form form={form} layout="vertical" onFinish={handleChangePassword}>
                    {!fromLogin && (
                      <>
                        <Form.Item label="" name="email" rules={[{ required: true, min: 8, message: "Por favor ingrese un correo válido", type: "email" }]}>
                          <Input prefix={<UserOutlined />} style={{ borderRadius: "2rem", padding: "0.8rem 1.2rem", fontSize: "0.8rem" }} minLength={8} placeholder={configMessages.form.emailPlaceholder} />
                        </Form.Item>
                        <Form.Item label="" name="oldPassword" rules={[{ required: true, min: 4, message: "Por favor ingrese su contraseña actual" }]}>
                          <Input.Password prefix={<LockOutlined />} style={{ borderRadius: "2rem", padding: "0.8rem 1.2rem", fontSize: "0.8rem" }} minLength={4} placeholder={configMessages.form.oldPasswordPlaceholder} />
                        </Form.Item>
                      </>
                    )}
                    <Form.Item label="" name="newPassword" rules={[{ required: true, min: 8, message: "La contraseña debe tener al menos 8 caracteres" }]}>
                      <Input.Password prefix={<LockOutlined />} style={{ borderRadius: "2rem", padding: "0.8rem 1.2rem", fontSize: "0.8rem" }} minLength={8} placeholder={configMessages.form.newPasswordPlaceholder} />
                    </Form.Item>
                    <Form.Item label="" name="confirmPassword" rules={[{ required: true, min: 8, message: "Por favor confirme su contraseña" }]}>
                      <Input.Password prefix={<LockOutlined />} style={{ borderRadius: "2rem", padding: "0.8rem 1.2rem", fontSize: "0.8rem" }} minLength={8} placeholder={configMessages.form.confirmPasswordPlaceholder} />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" disabled={!(config.enableLogin)} block style={{ borderRadius: "10rem", padding: "20px" }}>
                        {configMessages.form.buttonText}
                      </Button>
                    </Form.Item>
                  </Form>
                  <div style={{ textAlign: "center" }}>
                    <h4 style={{ color: "red" }}>{(config.errorMessage) || ''}</h4>
                  </div>
                  <hr />
                  <div style={{ textAlign: "center" }}>
                    <a style={{ fontSize: "80%", fontWeight: 400 }} href="/login">
                      Volver al inicio de sesión
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={0} sm={0} md={0} lg={10} xl={11}>
              {!isMobile && (
                <div className="bg-image image-change-password">
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </Content>

      <FooterLayout />
    </Layout>
  )
}

export default ChangePassword
